// Herda a cor do texto, então serve em qualquer botão e em qualquer tema. Quem pediu menos movimento
// ainda vê o giro, só que lento: parado, ele não diria que algo está acontecendo.
export const Spinner = () => (
    <span
        aria-hidden="true"
        className="inline-block size-4 shrink-0 animate-spin rounded-full border-2 border-current border-r-transparent motion-reduce:animate-[spin_2s_linear_infinite]"
    />
)
